import { fg } from '@atlaskit/platform-feature-flags';

// List of modules that should send performance metrics.
// Add new modules behind feature gate to monitor event volumes.
const allowlist = [
	// Jira Modules
	'jira:adminPage',
	'jira:customField',
	'jira:customFieldType',
	'jira:dashboardGadget',
	'jira:globalPage',
	'jira:issueAction',
	'jira:issueActivity',
	'jira:issueContext',
	'jira:issuePanel',
	'jira:projectPage',
	'jira:projectSettingsPage',

	// Confluence Modules
	'confluence:contentAction',
	'confluence:contentBylineItem',
	'confluence:globalPage',
	'confluence:globalSettings',
	'confluence:spacePage',
	'xen:macro',
];

export const getEnabledModulesForPerformanceProfiling = () => {
	// Rolling out UIM in-frame perf capture.
	if (fg('forge-ui-uim-perf-profiling-enabled')) {
		return [...allowlist, 'jira:uiModifications'];
	}

	return allowlist;
};
